import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  get window(): Window | null {
    return this.isBrowser ? window : null;
  }

  get document(): Document | null {
    return this.isBrowser ? document : null;
  }

  get href(): string | null {
    return this.isBrowser ? window.location.href : null;
  }

  get locationSearch(): string {
    return this.isBrowser ? window.location.search : '';
  }

  get locationOrigin(): string {
    return this.isBrowser ? window.location.origin : '';
  }

  get locationPathname(): string {
    return this.isBrowser ? window.location.pathname : '';
  }

  get documentURL(): string {
    return this.isBrowser ? window.document.URL : '';
  }

  get navigatorUserAgent(): string {
    return this.isBrowser ? window.navigator.userAgent : '';
  }  

  get navigatorUserPlatform(): string {
    return this.isBrowser ? window.navigator.platform : '';
  }  
  

  getComputedStyle(element: Element, pseudoElement?: string): CSSStyleDeclaration | null {
    if (this.isBrowser && this.window) {
      return this.window.getComputedStyle(element, pseudoElement);
    }
    return null;
  }


}
